export const config = {
// API_URL: 'http://agmd.bitxiatech.com:8011'
// API_URL: 'https://primafelicitas.invield.com'
API_URL: 'https://app.invield.com'
}